// Local translations
export const T = {
  en_GB: {
    prevYear: "Previous year",
    nextYear: "Next year",
    selectMonth: "Select month",
    thisMonth: "This month",
    clear: "Clear",
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    fullMonths: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
  },
  nb_NO: {
    prevYear: "Forrige år",
    nextYear: "Neste år",
    selectMonth: "Velg maaned",
    thisMonth: "Denne maaneden",
    clear: "Tøm",
    months: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
    fullMonths: [
      "Januar",
      "Februar",
      "Mars",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Desember",
    ],
  },
} as const;
